module.exports = __webpack_public_path__ + "static/media/buyu_pc_game.1413215.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/buyu_pc_game.mp4
// module id = Wjw9
// module chunks = 0